// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../library/utils/NetworkUtils.bs.js";
import * as RnrRepoConfig from "./RnrRepoConfig.bs.js";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";

var dummyRnRReport = {
        "cycle_category_aggregates": [
          {
            "category": "CUSTOMER_EXPERIENCE",
            "points": 800,
            "computers": [
              {
                "type": "ORDER_RATING",
                "min_rating": 4,
                "points": 10,
              }
            ]
          },
          {
            "category": "LOGIN_ACTIVITY",
            "points": 800,
            "computers": [
              {
                "type": "LOGIN_HOURS",
                "window_start_mins": 60,
                "window_end_mins": 120,
                "per_hour_points": 2,
              }
            ]
          },
          {
            "category": "ORDER_FULFILLMENT",
            "points": 400,
            "computers": [
              {
                "type": "ORDER_FULFILLMENT",
                "slabs": [
                  {
                    "order_count": 1,
                    "points": 2,
                  },
                  {
                    "order_count": 2,
                    "points": 4,
                  },
                  {
                    "order_count": 3,
                    "points": 6,
                  },
                  {
                    "order_count": 4,
                    "points": 8,
                  }
                ]
              }
            ]
          }

        ],
        "rewards": [
            {
              "entitlement_date": "2019-04-15",
              "id": 0,
              "type": "ORDER_FULFILLMENT",
              "points": 100,
              "status": "CLAIMED",
              "category": "ORDER_FULFILLMENT",
              "expiry_ts": 1959103730,
              "driver_cancelled_count": 0,
              "completed_count": 4,
            },
            {
              "entitlement_date": "2019-04-14",
              "id": 1,
              "type": "ORDER_RATING",
              "points": 301,
              "status": "UNCLAIMED",
              "category": "CUSTOMER_EXPERIENCE",
              "expiry_ts": 1959103730,
              "qualified_order_count": 3,
              "completed_order_count": 4,
            },
            {
              "entitlement_date": "2019-04-17",
              "id": 2,
              "type": "ORDER_RATING",
              "points": 102,
              "status": "CLAIMED",
              "category": "CUSTOMER_EXPERIENCE",
              "expiry_ts": 1959103730,
              "qualified_order_count": 3,
              "completed_order_count": 4,
            },
            {
              "entitlement_date": "2019-04-12",
              "id": 3,
              "type": "LOGIN_HOURS",
              "points": 203,
              "status": "CLAIMED",
              "category": "LOGIN_ACTIVITY",
              "expiry_ts": 1959103730,
              "login_hours": 8,
            },
            {
              "entitlement_date": "2019-04-15",
              "id": 4,
              "type": "LOGIN_HOURS",
              "points": 204,
              "status": "CLAIMED",
              "category": "LOGIN_ACTIVITY",
              "expiry_ts": 1959103730,
              "login_hours": 8,
            },
             {
              "entitlement_date": "2019-05-20",
              "id": 5,
              "type": "ORDER_FULFILLMENT",
              "points": 105,
              "status": "UNCLAIMED",
              "category": "ORDER_FULFILLMENT",
              "expiry_ts": 1959103730,
              "driver_cancelled_count": 1,
              "completed_count": 4,
            },
             {
              "entitlement_date": "2019-05-22",
              "id": 6,
              "type": "ORDER_FULFILLMENT",
              "points": 206,
              "status": "UNCLAIMED",
              "category": "ORDER_FULFILLMENT",
              "expiry_ts": 1959103730,
              "driver_cancelled_count": 0,
              "completed_count": 4,
            },
            {
              "entitlement_date": "2019-05-20",
              "id": 7,
              "type": "ORDER_RATING",
              "points": 107,
              "status": "UNCLAIMED",
              "category": "CUSTOMER_EXPERIENCE",
              "expiry_ts": 1959103730,
              "qualified_order_count": 3,
              "completed_order_count": 4,
            },
            {
              "entitlement_date": "2019-05-20",
              "id": 8,
              "type": "ORDER_RATING",
              "points": 308,
              "status": "UNCLAIMED",
              "category": "CUSTOMER_EXPERIENCE",
              "expiry_ts": 1959103730,
              "qualified_order_count": 3,
              "completed_order_count": 4,
            },
            {
              "entitlement_date": "2019-05-20",
              "id": 9,
              "type": "ORDER_RATING",
              "points": 109,
              "status": "UNCLAIMED",
              "category": "CUSTOMER_EXPERIENCE",
              "expiry_ts": 1959103730,
              "qualified_order_count": 3,
              "completed_order_count": 4,
            },
            {
              "entitlement_date": "2019-05-20",
              "id": 10,
              "type": "LOGIN_HOURS",
              "points": 210,
              "status": "UNCLAIMED",
              "category": "LOGIN_ACTIVITY",
              "expiry_ts": 1959103730,
              "login_hours": 8,
            },
            {
              "entitlement_date": "2019-04-14",
              "id": 11,
              "type": "LOGIN_HOURS",
              "points": 111,
              "status": "UNCLAIMED",
              "category": "LOGIN_ACTIVITY",
              "expiry_ts": 1959103730,
              "login_hours": 8,
            },
            {
              "entitlement_date": "2019-04-17",
              "id": 12,
              "type": "ORDER_FULFILLMENT",
              "points": 212,
              "status": "CLAIMED",
              "category": "ORDER_FULFILLMENT",
              "expiry_ts": 1959103730,
              "driver_cancelled_count": 0,
              "completed_count": 4,
            },
            {
              "entitlement_date": "2019-05-23",
              "id": 13,
              "type": "LOGIN_HOURS",
              "points": 0,
              "status": "UNCLAIMED",
              "category": "LOGIN_ACTIVITY",
              "expiry_ts": 1959103730,
              "login_hours": 8,
            },
          ],
        "milestones": [
            {
              "name": "Star",
              "points": 0,
              "award": null,
            },
            {
              "name": "Bronze Hero",
              "points": 100,
              "award": {
                "type": "FUEL",
                "awarded_at": 1561294089,
                "wallet_txn_id": "TXN_jERSRq-Vri4",
                "fuel_quantity": 2,
                "amount": 200,
              },
            },
            {
              "name": "Bronze Super Star",
              "points": 200,
              "award": {
                "type": "FUEL",
                "awarded_at": 1561294089,
                "wallet_txn_id": "TXN_jERSRq-Vri4",
                "fuel_quantity": 3,
                "amount": 300,
              },
            },
            {
              "name": "Silver Hero",
              "points": 400,
              "award": {
                "type": "INSURANCE",
                "awarded_at": 1568374107,
                "start_date": "2019-09-13",
                "end_date": "2019-09-13",
                "price": 200,
                "discount": 100,
                "benefit_type": "discount",
              },
            },
            {
              "name": "Platinum Super Star",
              "points": 800,
              "award": {
                "type": "DISTRIBUTION_CEREMONY",
                "awarded_at": 1571899305,
                "start_date": "2019-09-13",
                "end_date": "2019-09-13",
                "price": 500,
                "vehicle_id": 10,
              },
            },
            {
              "name": "Gold Hero",
              "points": 1000,
              "award": {
                "type": "FINAL_AWARD",
                "awarded_at": 1578915111,
                "start_date": "2019-09-13",
                "end_date": "2019-09-13",
                "multiplier": 3,
              },
            },
            {
              "name": "Gold Super Star",
              "points": 1100,
              "award": {
                "type": "PREMIUM",
                "awarded_at": 1571737715,
                "wallet_txn_id": "TXN_jERSRq-Vri4",
                "start_date": "2019-09-13",
                "end_date": "2019-09-13",
                "accept_advantage": 5,
              },
            },
            {
              "name": "Diamond Hero",
              "points": 1300,
              "award": {
                "type": "No",
                "awarded_at": 1569489779,
              /* //   "wallet_txn_id": "TXN_jERSRq-Vri4",
              //   // "awarded_at": 1566665066,
              //   "fuel_quantity": 5,
              //   "amount": 500, */
              },
            },
            {
              "name": "Diamond Super Star",
              "points": 1400,
              "award": {
                "type": "MONETARY",
                "awarded_at": 1569397287,
                "amount": 500,
              },
            },
            {
              "name": "Porter Hero",
              "points": 1600,
              "award": {
                "type": "DISTRIBUTION_CEREMONY",
                "awarded_at": 1569397287,
                "amount": 500,
              },
            },
            {
              "name": "Supro Super Star",
              "points": 25000,
              "award": {
                "type": "FUEL",
                "awarded_at": 1567451233,
                "wallet_txn_id": "TXN_jERSRq-Vri4",
                "fuel_quantity": 5,
                "amount": 500,
              },
            },
            {
              "points": 2000,
              "name": "Platinum Hero",
              "award": {
                "coupon_code": "XYSOPTRRDHWUROWPR",
                "expiry_date": "2020-12-30",
                "awarded_at": 1603513088,
                "coupon_scheme": {
                  "type": "percetage_discount",
                  "value": 5,
                  "summary": "5% discount with a maximum discount of 150",
                  "short_description": "This coupon is for oil and lubricants only, this coupon is for oil and lubricants only",
                  "rnr_sponsor": {
                    "name": "ceat_tyres",
                    "display_name": "Ceat Tyres",
                    "logo_url": "https://www.freepngimg.com/thumb/logo/62837-instagram-icons-photography-computer-logo-icon.png"
                  },
                  "scheme_details": [
                    "This coupon will allow you get maximum Rs 150 rs of discount This coupon will allow you get maximum Rs 150 rs of discount This coupon will allow you get maximum Rs 150 rs of discount",
                    "This coupon will allow you get maximum Rs 150 rs of discount only",
                    "This coupon will allow you get maximum only Rs 150 rs  of discount"
                  ],
                  "redemption_detail": {
                    "type": "VIDEO",
                    "video_url": "https://www.youtube.com/embed/tgbNymZ7vqY"
                  },
                  "terms_and_conditions": [
                    "Condition 1",
                    "Condition 2",
                    "Condition 3"
                  ],
                  "claim_actions": [
                    {
                      "description": "random desc",
                      "name": "Purchase now",
                      "link": "https://www.amazon.in/"
                    },
                    {
                      "description": "random desc 2",
                      "name": "Buy now",
                      "link": "https://www.Flipkart.in/"
                    }
                  ]
                },
                "type": "COUPON_AWARD"
              }
            },
            {
              "points": 12500,
              "name": "Silver Super Star",
              "award": {
                "coupon_code": "ZAF5-T6DXUW-AMEEBR",
                "expiry_date": "2020-12-30",
                "awarded_at": 1603513088,
                "coupon_scheme": {
                  "type": "flat_discount",
                  "value": 480,
                  "summary": "flat Rs 480 discount",
                  "short_description": "you can reveal 120 rs each time",
                  "rnr_sponsor": {
                    "name": "exon_mobile",
                    "display_name": "Exon Mobile",
                    "logo_url": "s3_link"
                  },
                  "scheme_details": [
                    "This coupon will allow you get Rs 120 rs of discount",
                    "coupon can be used 4 times, allowing you to get total discount Rs: 480",
                    "Oil/Lubricants will be delivered free to your provided address"
                  ],
                  "redemption_detail": {
                    "type": "TEXT",
                    "steps": [
                      "Go to amazon",
                      "Select a product",
                      "go to cart",
                      "apply coupon",
                      "checkout"
                    ]
                  },
                  "terms_and_conditions": [
                    "Condition 1",
                    "Condition 2",
                    "Condition 3"
                  ],
                  "claim_actions": [
                    {
                      "description": "random desc",
                      "name": "Purchase now",
                      "link": "https://www.amazon.in/"
                    },
                    {
                      "description": "random desc 2",
                      "name": "Buy now",
                      "link": "https://www.Flipkart.in/"
                    }
                  ]
                },
                "type": "COUPON_AWARD"
              }
            }
          ],
          "rnr_cycle": {
            "start_date": "2019-04-15",
            "end_date": "2019-04-15",
            "geo_region_id": "2",
          },
          "vehicle_category": "2_wheeler",

        };

var dummyRnRReportCycleEnd = {"status":422,"type":"rnr_cycle_not_found","message":"Porter Reward Program has ended. Thank you for participating. A New Porter Reward Program will be announced shortly."};

var dummyRnrClaimResponse = {
        "success": true,
        "message": "string",
        "crossed_milestone": {
          "name": "Platinum Hero",
          "points": 700,
          "award": {
                "type": "INSURANCE",
                "awarded_at": 1568374107,
                // "wallet_txn_id": "TXN_jERSRq-Vri4",
                "start_date": "2019-09-13",
                "end_date": "2019-09-13",
                // "accept_advantage": 5,
                price: 200,
                discount: 100,
                benefit_type: "price",

              },
        },
      };

var dummyBannersResponse = {
        "banners": [
            {
                "banner_name": "ASSUREKIT_INSURANCE",
                "banner_on_click_link": "https://porter.assurekit.com/porter/login?auth_token=8cf2a2c0b2448ff2be9469be7f78b6f6&owner_mobile=6666668343&driver_mobile=6666668343"
            },
            {
                "banner_name": "LENDING_LANDING_PAGE",
                "banner_on_click_link": "https://frontend-lending-staging.porter.in/login?owner_mobile=6666665402&auth_token=8JwrD7wrVHnYdGcyLzx59w&msisdn=6666665402025&uuid=09245fa8-01d5-4ec9-9e57-685781120901"
            }
        ]
     };

function fetchRnrReport(uuid, _authToken, _lang) {
  Logger$Catalyst.trace({
        requestUrl: "fetchRnrReportApiCalled"
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnRReport
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(RnrRepoConfig.RnrReportResponseConverter.execute, result);
                            });
                }), "");
}

function claimRnrReward(uuid, _authToken, _lang, _reward_ids) {
  Logger$Catalyst.trace({
        requestUrl: "claimRnrRewardApiCalled"
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyRnrClaimResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(RnrRepoConfig.RnrClaimResponseConverter.execute, result);
                            });
                }), "");
}

function fetchRnrBanners(uuid, _authToken) {
  Logger$Catalyst.trace({
        requestUrl: "fetchRnrBannersApiCalled"
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyBannersResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(RnrRepoConfig.RnrBannersResponseConverter.execute, result);
                            });
                }), "");
}

var RnrRepo = {
  dummyRnRReport: dummyRnRReport,
  dummyRnRReportCycleEnd: dummyRnRReportCycleEnd,
  dummyRnrClaimResponse: dummyRnrClaimResponse,
  dummyBannersResponse: dummyBannersResponse,
  fetchRnrReport: fetchRnrReport,
  claimRnrReward: claimRnrReward,
  fetchRnrBanners: fetchRnrBanners
};

export {
  RnrRepo ,
  
}
/* NetworkUtils Not a pure module */
